import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MDButton from "../../MDButton";
import { CircularProgress } from "@mui/material";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { storeMachineGroup } from "../../../actions/machine-group/machine-group";
import { storePeymankar } from "../../../actions/peymankar/peymankar";
import { Button } from "@heroui/button";

export default function CreatPeymankarComponent(){
    const router = useNavigate();
    const [pending , setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    async function storeNewMachineGroups(e){
        e.preventDefault();
        const formData = new FormData(e.target);
        setLoading(true);
        const state = await storePeymankar(formData);
        setLoading(false);
        if(state.status === "success"){
            toast.success(state.message);
            router('/peymankar');
        }else{
            toast.error(state.message);
        }
    }
    const changeTextColor = () => {
        setIsOptionSelected(true);
    };
    return (
      <DashboardLayout>
          <div className="flex flex-col gap-9">
              <form onSubmit={storeNewMachineGroups}>
                  <div
                    className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                      <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
                          <h3 className="font-medium text-black dark:text-white">
                              ثبت پیمانکار
                          </h3>
                      </div>
                      <div className="flex flex-col gap-5 p-6">
                          <div className="flex flex-wrap gap-5">
                              <div className="flex-1">
                                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                      عنوان
                                  </label>
                                  <input
                                    type="text"
                                    name='name'
                                    placeholder="..."
                                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                  />

                              </div>
                              <div className="flex-1">
                                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                      شماره شبا
                                  </label>
                                  <input
                                    type="text"
                                    name='shabanumber'
                                    placeholder="..."
                                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                  />

                              </div>
                              <div className="flex-1">
                                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                      شماره موبایل
                                  </label>
                                  <input
                                    type="number"
                                    name='cellphone'
                                    placeholder="..."
                                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                  />

                              </div>
                          </div>

                          <div className={"flex mt-10 w-1/5"}>
                              <Button isLoading={pending} type={"submit"} variant="gradient"
                                      className="!bg-blue-500 !py-5 hover:bg-blue-600 text-white w-full">
                                  ایجاد
                              </Button>
                          </div>
                      </div>
                  </div>
              </form>
          </div>
      </DashboardLayout>
    );
}